import { HttpRequestConfig, ResponseHeaders } from './entities';
import { HttpClient } from './interfaces';

export class HttpClientDecorator implements HttpClient {
  constructor(private readonly httpClient: HttpClient) {}

  delete<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return this.httpClient.delete(url, config);
  }

  get<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return this.httpClient.get(url, config);
  }

  post<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return this.httpClient.post(url, config);
  }

  put<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return this.httpClient.put(url, config);
  }

  patch<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return this.httpClient.patch(url, config);
  }

  setHeaders(headers: ResponseHeaders): Promise<void> {
    return this.httpClient.setHeaders(headers);
  }

  getHeaders(): ResponseHeaders {
    return this.httpClient.getHeaders();
  }
}
